import gql from "graphql-tag";
import type { ApolloClient } from "@apollo/client";

import type {
  GetSessionParamQuery,
  GetSessionParamQueryVariables,
} from "types/graphql";

export function getSessionParam(
  client: ApolloClient<object>,
  { sessionToken, sessionScope, identityHash }: GetSessionParamQueryVariables
): Promise<GetSessionParamQuery["getSessionParam"]> {
  return new Promise((resolve, reject) => {
    const QUERY = gql`
      query getSessionParam(
        $sessionToken: ID!
        $sessionScope: ScopeTypes!
        $identityHash: String!
      ) {
        getSessionParam(
          sessionToken: $sessionToken
          sessionScope: $sessionScope
          identityHash: $identityHash
        ) {
          success
          error {
            message
            errorCode
          }
          sessionParams {
            expiresOn
            payload
          }
        }
      }
    `;

    const result = client.query<
      GetSessionParamQuery,
      GetSessionParamQueryVariables
    >({
      query: QUERY,
      variables: {
        sessionToken,
        sessionScope,
        identityHash,
      },
    });
    result.then(
      (response) => {
        if (response.data) {
          resolve(response.data.getSessionParam);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- pre-existing contract: rejects the raw Apollo response
          reject(response);
        }
      },
      (error: Error) => {
        console.error(error);
        reject(error);
      }
    );
  });
}

export default {
  getSessionParam,
};
